import React from 'react'
import { QuickbetState, state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { observeImmutable } from '@core/Components/HOCs/observe'
import { BetSlipReceipt, KambiSportsReceipt, QuickbetReceipt } from './Components'

export const Receipt: React.ComponentClass = observeImmutable(quickbetState$, ({ record }) => {
  const quickbet: QuickbetState = record.toJS()
  const receipt = quickbet.receipt
  if (!quickbet.betPlaced || !receipt || !receipt.data) {
    return null
  }

  if (receipt.type === 'Bet Slip' && receipt.data) {
    return <BetSlipReceipt responses={receipt.data} />
  }

  if (receipt.type === 'Kambi' && receipt.data) {
    return <KambiSportsReceipt coupon={receipt.data} />
  }

  if (receipt.type === 'Single' && receipt.data) {
    const { selection, selectionDetails } = quickbet

    return (
      <QuickbetReceipt
        selection={selection}
        selectionDetails={selectionDetails}
        receiptData={receipt.data}
      />
    )
  }

  return null
})

Receipt.displayName = 'Receipt'
